import { stat } from "fs";
import {
  FETCH_TRANSACTIONS_HIGHLIGHTS_FAILURE,
  FETCH_TRANSACTIONS_HIGHLIGHTS_REQUEST,
  FETCH_TRANSACTIONS_HIGHLIGHTS_SUCCESS,
  FETCH_TRANSACTIONS_HIGHLIGHTS_REMOVE
} from "../types";

interface Transaction {
  type: string;
  count: string;
  amount: string;
}

interface TransactionData {
  transactions: Transaction[];
}

interface PaymentGatewayState {
  highlightloading : boolean|null;
  highlightData: TransactionData | null;
  highlightError: string | null;
}

const initialState: PaymentGatewayState = {
  highlightloading:null,
  highlightData: null,
  highlightError: null,
};

const paymentGatewayHighlightsReducer = (
  state = initialState,
  action: any
): PaymentGatewayState => {
  switch (action.type) {
    case FETCH_TRANSACTIONS_HIGHLIGHTS_REQUEST:
      return {
        ...state,
        highlightloading:true,
        highlightError: null,
      };
    case FETCH_TRANSACTIONS_HIGHLIGHTS_SUCCESS:
      return {
        ...state,
        highlightData: action.payload,
        highlightloading:false,
        highlightError: null,
      };
    case FETCH_TRANSACTIONS_HIGHLIGHTS_FAILURE:
      return {
        ...state,
        highlightError: action.error,
        highlightloading:false,
        highlightData: null
      };
    case FETCH_TRANSACTIONS_HIGHLIGHTS_REMOVE:
      return {
        highlightloading :null,
        highlightError: null,
        highlightData: null
      };
    default:
      return state;
  }
};

export default paymentGatewayHighlightsReducer;
